module.exports = __webpack_public_path__ + "static/media/seguro.ef82733a.pdf";